<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/ECV_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">ECVs</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>A gestão de uma ECV – Empresa Credenciada de Vistoria junto ao Detran pode não ser uma tarefa fácil. Por
              isso é essencial a expertise de mercado que só um parceiro confiável possui para orientar sua empresa a
              tomar as melhores decisões..</p>
            <p>Há mais de 10 anos no mercado auxiliando nas operações de ECVs, a Union oferece o suporte da criação à
              manutenção e funcionamento junto ao Órgão do Estado. Nosso compromisso é o seu sucesso.</p>
          </div>
        </div>
        <div class="right">
          <figure class="fig">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/ecv-@2x.png">
          </figure>
        </div>
      </div>

    </div>
  </section>

  <app-contact-box></app-contact-box>

</main>
